// extracted by mini-css-extract-plugin
var _1 = "RequestTagMultiValuedList-modulemoreBtn__jSjoP MultiValuedListMoreButton-moduleMultiValuedListMoreButton__uXKl3";
export { _1 as "moreBtn" }
